import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import ToastMessages from '../../components/ToastMessages/toastMessages';
import { api } from '../../services/api';
import { DistributorForm } from '../../services/types';

export default function useRegisterDistributor() {
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  async function execute(data: DistributorForm) {
    try {
      setLoading(true);
      const response = await api.post('v1/backoffice/distributors', {
        name: data.name,
        cnpj: data.cnpj,
        zipCode: data.zipCode,
        state: data.state,
        city: data.city,
        neighborhood: data.neighborhood,
        streetAddress: data.streetAddress,
        streetNumber: data.streetNumber,
        phone: data.phone,
        email: data.email,
        complement: data.complement,
        cellPhone: data.cellPhone,
        stateRegistration: data.stateRegistration,
        feeType: data.feeType,
        fee: Number(data.fee),
      });

      if (response.status === 201) {
        toast.success(ToastMessages.distributor.success.registerDistributor),
          history.push('/home/companies');
      }
    } catch (error) {
      if (!Array.isArray((error as any).response.data.message)) {
        toast.error(ToastMessages.general.error.genericError);
      } else {
        (error as any).response.data.message.map((err: any) =>
          toast.error(ToastMessages.distributor.error.registerDistributor),
        );
      }
    } finally {
      setLoading(false);
    }
  }

  return { execute, loading };
}
